import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons';
import { withdrawal } from "../../API/player";
import { FilterDynamicText } from "../../API/admin";

import { useSnackbar } from 'notistack';
import Swal from "sweetalert2";
import Loader from '../../views/admin/Common/Loader'
// import Loader from '../../Common/Loader'

import { getPlayerSportsLatest } from "../../API/player";
import {
  CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CFormInput,
  CForm,
} from '@coreui/react'
const Withdrwal = ({onModalOpen, OnModalClose}) => {
  let navigate = useNavigate();

  const [visible, setVisible] = useState(false)
  const [Sports, setSports] = useState([])
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [loaderStatus, setloaderStatus] = useState(false);
  const [dynamicHeading, setDynamicHeading] = useState({});

  useEffect(() => {
    let callAPI = async () => {

      let res = await getPlayerSportsLatest();
      console.log(res.data.data.sports)

      if (res.data.status) {
        const availableSports = res.data.data.sports.filter(sport => !res.data.data.withdrawan_sports.includes(sport));

        setSports(availableSports);

        const firstAvailableSport = availableSports.find(sport => sport !== res.data.data.withdrawan_sports[0]);
        setSelectedSport(firstAvailableSport)
      } else {

      }
    }

    let callAPIDynamic = async () => {
      let formData = {
        "data": null
      }
      let res = await FilterDynamicText(formData);
      if (res.data.status) {
        console.log(res.data.data)
        setDynamicHeading(res.data.data)
      }
    }
    callAPI()
    callAPIDynamic()
  }, [])
  const [selectedSport, setSelectedSport] = useState('');
  const sports = ['badminton', 'table_tenis', 'bowling', '2k_run'];

  // handle function for select
  const handleSelectChange = (event) => {
    setSelectedSport(event.target.value);
    // You can also add any additional logic here, like triggering API calls or other state updates.
    console.log(`Selected sport: ${event.target.value}`);
  };

  const handelSubmit = () => {

    console.log(selectedSport);
    Swal.fire({

      title: dynamicHeading.confirmation_withdrawal
      ? dynamicHeading.confirmation_withdrawal.title :"Are you sure to withdrawal from game?",
      text: dynamicHeading.confirmation_withdrawal
        ? dynamicHeading.confirmation_withdrawal.value : "After withdrawal, you will not be able to continue with games",

      // icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "Close"

    }).then(async (result) => {
      if (result.isConfirmed) {
        let formData = {
          "game_type": selectedSport
        }
        console.log("setting loder ");
        setloaderStatus(true)
        setVisible(!visible)
        let res = await withdrawal(formData)
        if (res.data.status) {
          setloaderStatus(false)
          Swal.fire({
            title: dynamicHeading.successfull_withdrwal
              ? dynamicHeading.successfull_withdrwal.title :"You have withdrwan from game!",
            text: dynamicHeading.successfull_withdrwal
              ? dynamicHeading.successfull_withdrwal.value : "Your withdarwal request has been proceed, thank you",
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Logout",
            showCancelButton: true,
            cancelButtonText: "Continue",
            cancelButtonColor: ":#d33",
            cancelButtonText: "Close"

          }).then(async (result) => {
            if (result.isConfirmed) {
              navigate('/logout')
            } else {
              navigate('/dashboard')
            }
          })

        } else {
          setloaderStatus(false)
          res.data.liveMatch ? 
          Swal.fire({

            title: "Matches Are Live",
            text:"You cannot withdraw at the moment as the matches for the selected sports are currently live.",
            // icon: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "OK"
          })
         :Swal.fire({

          title: "Unable to withdraw",
          text:"Something went wrong you can not withdraw at the mooment",
          // icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK"
        })

        }
      }
    });
  }
  return (
    <>
      {loaderStatus ? <Loader /> : null}
      <CButton className="text-white edit_profmodal_all_btn ms-3"  onClick={() => {setVisible(!visible) ;
        onModalOpen()}} style={{background:"#202020"}}>Withdraw</CButton>
      <CModal
        alignment="center"
        scrollable
        visible={visible}
        onClose={() => {setVisible(false); OnModalClose() }}
        aria-labelledby="VerticallyCenteredScrollableExample2"
      >
        <CModalHeader>
          <CModalTitle id="VerticallyCenteredScrollableExample2">Withdraw from sports</CModalTitle>
        </CModalHeader>
        <CModalBody>

          <select className="form-select" value={selectedSport} onChange={handleSelectChange}>

            {Sports.length > 0 ? (
              Sports.map((data, index) => (
                <option key={index} value={data}>
                  {data === "badminton"
                    ? "Badminton"
                    : data === "table_tenis"
                      ? "Table Tennis"
                      : data === "bowling"
                        ? "Bowling"
                        : data === "2k_run"
                          ? "2k Run"
                          : "N/A"}
                </option>
              ))
            ) : <option value="" disabled> No Sport available</option>}

          </select>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => {setVisible(false) ; OnModalClose()}}>
            Close
          </CButton>
          <CButton onClick={() => { handelSubmit() }} color="primary" disabled={Sports.length === 0}>Withdraw</CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}
export default Withdrwal